module.exports = __webpack_public_path__ + "static/icon-baby.3d5cea7e.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-baby.png
// module id = 282
// module chunks = 2